import React from 'react';
import UserLinkCell from './UserLinkCell';

function createUserLinkCell(type = 'edit') {
    return (props) => {
        return <UserLinkCell {...props} type={type} />;
    };
}

export default createUserLinkCell;
